/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityKeyAIcon20Solid = forwardRef('SecurityKeyAIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.667 15.833A5.836 5.836 0 0 0 12.148 12h2.435c.23 0 .417.187.417.417v.333c0 .69.56 1.25 1.25 1.25h1.5c.69 0 1.25-.56 1.25-1.25v-3.5C19 8.56 18.44 8 17.75 8h-5.602A5.836 5.836 0 0 0 .833 10a5.833 5.833 0 0 0 5.834 5.833Zm0-3.333a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" })));
});
